export function _base64ToArrayBuffer(base64: string): Uint8Array {
	const binary_string = window?.atob(base64);
	const len = binary_string.length;
	const bytes = new Uint8Array(len);
	for (let i = 0; i < len; i++) {
		bytes[i] = binary_string.charCodeAt(i);
	}
	return bytes;
}

export function getMarketHoursFromState(marketState: string | undefined) {
	if (marketState === 'PREPRE') {
		return 0;
	}
	if (marketState === 'PRE') {
		return 1;
	}
	if (marketState === 'REGULAR') {
		return 2;
	}
	if (marketState === 'POST') {
		return 3;
	}
	if (marketState === 'POSTPOST') {
		return 4;
	}
	return null;
}

export function getMarketHoursFromHours(marketState?: string) {
	if (marketState === 'PREPRE') {
		return 0;
	}
	if (marketState === 'PRE') {
		return 1;
	}
	if (marketState === 'REGULAR_MARKET') {
		return 2;
	}
	if (marketState === 'POST') {
		return 3;
	}
	if (marketState === 'POSTPOST') {
		return 4;
	}
	return null;
}
